<template>
  
  <v-app>      
        <v-toolbar color="white" fixed app>
          <v-toolbar-title class="headline">
            <img height="40px" src="./assets/logo.svg"  /><h4 class="titolo"> {{ $t('key001') }}</h4>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-side-icon style="color: #151B42" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        </v-toolbar>
    
    <!-- <v-navigation-drawer
      fixed
      v-model="drawer"
      app
      dark
      class="secondary"
      stateless
      right
      value="true"
      color="#151B42"
      
    > -->
    
    <v-navigation-drawer style="background-color:#151B42" v-model="drawer" app right temporary>
      <v-toolbar flat color="#151B42">
        <v-list>
          <v-list-tile>
            <v-list-tile-title style="color: #4EABDD" class="title">{{$t('key351')}}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-btn flat style="color: white" @click="english">English</v-btn>
      <v-btn flat style="color: white" @click="italiano">Italiano</v-btn>
      <v-divider></v-divider>
      <v-list>
        <v-list-tile
          value="true"
          v-for="(item, i) in items"
          :key="i"
          @click="Redirect(item.route != ''?item.route:item.href)"
          :disabled="item.disabled"
        >
          <v-list-tile-action>
            <v-icon :style="$route.path === item.route || $route.path.split('/',2)[1] === item.route .split('/',2)[1] ? 'color: #4EABDD' : 'color: white'" v-html="item.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title :style="$route.path === item.route || $route.path.split('/',2)[1] === item.route .split('/',2)[1] ? 'color: #4EABDD' : 'color: white'" v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-btn flat style="color: #4EABDD" @click="logout">Logout</v-btn>
    </v-navigation-drawer>
    <v-content>
      <v-card v-if="visualizzaRefresh">
      <v-card-title>Gentile cliente, stai visualizzando una versione del portale non aggiornata. Clicca sul pulsante "Ricarica" per scaricare l'ultima versione (verrai reindirizzato alla pagina di login). <v-btn style="box-shadow: none; color: white;" color="#4EABDD" @click="ricarica()">Ricarica</v-btn></v-card-title>
      <v-card-actions></v-card-actions>
    </v-card>
      <router-view />
    </v-content>
    <v-layout justify-center>
      <v-dialog v-model="errore_cappario" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">ERRORE DI CARICAMENTO CAPPARIO</v-card-title>
          <v-card-text >Gentile utente, si è verificato un errore con il caricamento del cappario. Ti preghiamo di procedere nuovamente al login sui nostri sistemi prima di procedere</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="#4EABDD" text @click="ErroreCappario()">TORNA AL LOGIN</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-app>
</template>

<script>
import axios from "axios";
export default {
  name: "App",
  components: {},
  mounted() {
    this.$store.subscribe((mutation, state) => {
      if(mutation.type === "errore_cappario" && mutation.payload === true){
        console.log(mutation.type);
        console.log(mutation.payload);
        this.errore_cappario = true;
      }
    });
    this.items = [];
  },
  data() {
    return {
      drawer: true,
      items: [{}],
      errore_cappario: false,
      visualizzaRefresh: false,
    };
  },
  created() {
    axios.get(this.$store.state.servicePath + "/api/ArDatiApps/1/" + this.$store.state.version)
    .then(res=>{
      if(res.data){
        this.visualizzaRefresh = false;
      }
      else{
        this.visualizzaRefresh = true;
      }
    });
    this.$vuetify.lang.current = 'it-IT';
    this.$on("benvenuto", () => {
      this.loadMenu();
    });
  },
  methods: {
    ricarica(){
      this.$router.push({ path: `/` });
      location.reload(true);
    },
    Redirect(link){
      if(link.includes("http")){
        window.open(link);
      }
      else{
        this.$router.push({ path: link });
      }
    },
    loadMenu() {
        this.items = [];
        this.$store.state.userdata.menus.forEach(element => {
          var eldes = element.descrizione
          if(navigator.language!='it-IT') {
            if(element.descrizione=='Rubrica') {
              eldes="Database";
            }
            if(element.descrizione=='Inserimento ritiri') {
              eldes="Enter pick up order";
            }
            if(element.descrizione=='Località impervie') {
              eldes="Remote localities";
            }
            if(element.descrizione=='Località disagiate') {
              eldes="Remote localities";
            }
            if(element.descrizione=='Bollettazione') {
              eldes="Enter shipment";
            }
          }
          var el = {
            icon: element.icona,
            title: element.descrizione,
            route: element.route,
            href: element.href,
            disabled: false
          };
          this.items.push(el);
        });        
    },
    logout: function() {
      this.$store.dispatch("logout").then(() => {
        this.items = [];
        this.$router.push("/");
      });
    },
    ErroreCappario(){
      this.errore_cappario = false;
      window.location.href = "/#/";
    },
    english() {
      this.$i18n.locale="en"
      axios.defaults.headers.common['Language'] = "en-US";
      this.items = [];
      this.$store.state.userdata.menus.forEach(element => {
        var eldes = element.descrizione
        if(element.descrizione=='Rubrica') {
          eldes="Database";
        }
        if(element.descrizione=='Inserimento ritiri') {
          eldes="Enter pick up order";
        }
        if(element.descrizione=='Località impervie') {
          eldes="Remote localities";
        }
        if(element.descrizione=='Località disagiate') {
          eldes="Remote localities";
        }
        if(element.descrizione=='Bollettazione') {
          eldes="Enter shipment";
        }
        if(element.descrizione=='Localtià disagiate Francia') {
          eldes="France remote localities";
        }
        if(element.descrizione=='Località balneari') {
          eldes="Seaside localities";
        }
        if(element.descrizione=='Manuale bollettazione') {
          eldes="Enter shipment manual";
        }
        if(element.descrizione=='Tracking spedizioni') {
          eldes="Shipments tracking";
        }
        if(element.descrizione=='Tracking ritiri') {
          eldes="Pick up orders tracking";
        }
        if(element.descrizione=='Download POD massivo') {
          eldes="Massive POD download";
        }
        if(element.descrizione=='Località disagiate/impervie/balneari') {
          eldes="Remote localities";
        }
        var el = {
          icon: element.icona,
          title: eldes,
          route: element.route,
          href: element.href,
          disabled: false
        };
        this.items.push(el);
      });        
    },
    italiano() {
      this.$i18n.locale="it"
      axios.defaults.headers.common['Language'] = "it-IT";
      this.items = [];
      this.$store.state.userdata.menus.forEach(element => {
        var el = {
          icon: element.icona,
          title: element.descrizione,
          route: element.route,
          href: element.href,
          disabled: false
        };
        this.items.push(el);
      });        
    }
  }
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: "hk-grotesk";
  src: local("hk-grotesk"),
  url(./fonts/hk-grotesk/HKGrotesk-Regular.otf) format("truetype");
}

.highlighted-arco{
  color:#4EABDD;
}
html, body {
  font-family: "hk-grotesk";
  color: #151B42;
}
#app{
  
  font-family: "hk-grotesk";
  color: #151B42;
}
.v-slider__thumb{
  cursor:pointer;
  height:42px;
  width:42px;
}
.centered-input{
  text-align: center;
}

.titolo{
  font-family: "hk-grotesk";
  margin-top: -40px;
  margin-left: 180px;
  color: #151B42;
}
p{
  font-family: "hk-grotesk";
}
h1,h2,h3,h4,h5,h6{
  font-family: "hk-grotesk";
}
input{
  font-family: "hk-grotesk";
}

</style>

